var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 15.5H12.0952L13.8745 13.4242C14.7544 12.3976 15.238 11.0902 15.238 9.73812V9.73812C15.238 8.34889 14.6862 7.01655 13.7039 6.03421C12.7215 5.05187 11.3892 4.5 9.99997 4.5V4.5C8.61075 4.5 7.27842 5.05186 6.29609 6.03419C5.31376 7.01652 4.7619 8.34884 4.7619 9.73806V9.73806C4.7619 11.0901 5.24555 12.3976 6.12545 13.4241L7.90474 15.4999H4.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderSymbol);
export default ForwardRef;